import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import API from "../services/ApiService";

export default function VerifyPage() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [finished, setFinished] = useState(false);

    useEffect(() => {
        const verify = async () => {
            try {
                await API.verifyAccount(token);
                toast.success("Account verified successfully! You can now log in.");
            } catch (error) {
                toast.error("Verification failed. The token may be invalid or expired.");
            } finally {
                setFinished(true);
            }   
        };

        verify();
    }, [token]);

    useEffect(() => {
        if (finished) {
            setTimeout(() => {
                navigate("/");
            }, 2000);
        }
    }, [finished]);

    return (
        <div className="verify-page">
            <h1 className="verification-title">Verifying your account</h1>
            <p>After verification, you will be redirected to the login page.</p>
        </div>
    )
}